import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { Box, Grid } from "@mui/material";
import "../../input/validation.js";
import "../../input/DatePicker.js";
import "../../input/DateRangePicker.js";
import "../../input/StyledInput.js";
import { FormTextInputDefault } from "../../input/FormInput.js";
import "../../input/StyledFormInputHoc.js";
import "moment-timezone";
import "../../input/DateSinglePicker.localize.js";
import "../../input/hooks.js";
import "../../label/EmptyLabel.js";
import { withLabel } from "../../label/LabelHoc.js";
const localized = defineMessages({
  valueRangeValue: {
    id: "ValueRangeFilter_valueRangeValue",
    defaultMessage: "Value"
  },
  firstValueRangeInput: {
    id: "ValueRangeFilter_firstValueRangeInput",
    defaultMessage: "From"
  },
  secondValueRangeInput: {
    id: "ValueRangeFilter_secondValueRangeInput",
    defaultMessage: "To"
  }
});
function RelativeRangeInner({ value, onChange, showTo, showFrom, fieldState }) {
  const { formatMessage } = useIntl();
  const showBoth = showTo && showFrom;
  const localizeFirstInput = showTo ? localized.firstValueRangeInput : localized.valueRangeValue;
  const localizeSecondInput = showFrom ? localized.secondValueRangeInput : localized.valueRangeValue;
  function getFromFieldErrorState() {
    const isFieldErrorIncluded = fieldState?.error?.message?.includes(formatMessage(localized.firstValueRangeInput));
    const replacedMessage = isFieldErrorIncluded ? fieldState.error.message.replace(formatMessage(localized.firstValueRangeInput), formatMessage(localizeFirstInput)) : null;
    return showFrom && isFieldErrorIncluded ? {
      ...fieldState,
      error: {
        ...fieldState.error,
        message: replacedMessage
      }
    } : void 0;
  }
  function getToFieldErrorState() {
    const isFieldErrorIncluded = fieldState?.error?.message?.includes(formatMessage(localized.secondValueRangeInput));
    const replacedMessage = isFieldErrorIncluded ? fieldState.error.message.replace(formatMessage(localized.secondValueRangeInput), formatMessage(localizeSecondInput)) : null;
    return showTo && isFieldErrorIncluded ? {
      ...fieldState,
      error: {
        ...fieldState.error,
        message: replacedMessage
      }
    } : void 0;
  }
  function handleFromKeyDown(e) {
    if (e.key === "Backspace" && value.from === 0) {
      onChange({
        from: void 0,
        to: value.to
      });
    }
  }
  function handleToKeyDown(e) {
    if (e.key === "Backspace" && value.to === 0) {
      onChange({
        from: value.from,
        to: void 0
      });
    }
  }
  return /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(Grid, { container: true, spacing: 1 }, showFrom ? /* @__PURE__ */ React.createElement(Grid, { size: { xs: 12, md: showBoth ? 6 : 12 } }, /* @__PURE__ */ React.createElement(
    FormTextInputDefault,
    {
      key: "from",
      value: value.from,
      onChange: (e) => onChange({
        from: Number(e?.target?.value),
        to: value.to
      }),
      fieldState: getFromFieldErrorState(),
      hideLabel: true,
      placeholder: localizeFirstInput,
      type: "number",
      onKeyDown: handleFromKeyDown
    }
  )) : null, showTo ? /* @__PURE__ */ React.createElement(Grid, { size: { xs: 12, md: showBoth ? 6 : 12 } }, /* @__PURE__ */ React.createElement(
    FormTextInputDefault,
    {
      key: "to",
      value: value.to,
      onChange: (e) => onChange({
        from: value.from,
        to: Number(e?.target?.value)
      }),
      fieldState: getToFieldErrorState(),
      hideLabel: true,
      placeholder: localizeSecondInput,
      type: "number",
      onKeyDown: handleToKeyDown
    }
  )) : null));
}
const RelativeRange = withLabel(RelativeRangeInner);
export {
  RelativeRange,
  RelativeRangeInner,
  localized
};
//# sourceMappingURL=RelativeRange.js.map
